<template>
    <v-dialog persistent
              @keydown.esc="cancel"
              v-model="openDialog"
              :retain-focus="false"
              width="550" style=" min-height: 350px">
        <v-card  >
            <v-card-title class="primary" >
                <h3 class="white--text">Επιβεβαίωση Ενέργειας</h3>
                <v-spacer></v-spacer>
                <v-icon @click="cancel" color="white">close</v-icon>
            </v-card-title>

            <v-card-text style="background-color: #eaeaea" class="justify-center  pt-12">
                <v-row>
                    <v-col>
                        <h3 class="black--text">{{message}}</h3>
                    </v-col>
                </v-row>
            </v-card-text>


            <v-card-actions style="background-color: #eaeaea" class="justify-center pb-12 pt-6">
                <v-btn @click="cancel" style="text-transform: none !important;" large rounded outlined color="black">
                    Άκυρο
                    <v-icon size="25" color="black"  right dark> mdi-close-circle </v-icon>
                </v-btn>

                <v-btn  @click="confirm" style="text-transform: none !important;" large rounded outlined color="black">
                    Επιβεβαίωση
                    <v-icon size="25" color="black"  right dark> mdi-checkbox-marked-circle </v-icon>
                </v-btn>
            </v-card-actions>

        </v-card>
    </v-dialog>
<!--    <popup-modal ref="popup">-->
<!--        <h2 style="margin-top: 0">{{ title }}</h2>-->
<!--        <p>{{ message }}</p>-->
<!--        <div class="btns">-->
<!--            <button class="cancel-btn" @click="cancel">{{ cancelButton }}</button>-->
<!--            <span class="ok-btn" @click="confirm">{{ okButton }}</span>-->
<!--        </div>-->
<!--    </popup-modal>-->
</template>

<script>
	export default {
		name: 'DistributionRemovalDialog',
		data: () => ({
            openDialog:false,
			message: 'Προσπαθείτε να απενεργοποιήσετε Σημείο Διανομής που έχετε αντιστοιχίσει σε επιλεγμένα συγγράμματά σας για το υπό διαμόρφωση έτος, είστε σίγουρος/η πως επιθυμείτε την αφαίρεσή του;'
		}),

		methods: {
			show() {
				this.openDialog = true;
			},

			confirm() {
				this.$emit('remove-after-confirm');
				this.openDialog = false;
			},

			cancel() {
				this.openDialog = false;
			},
		},
	}
</script>


<style scoped>
    .btns {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
    }

    .ok-btn {
        color: red;
        text-decoration: underline;
        line-height: 2.5rem;
        cursor: pointer;
    }

    .cancel-btn {
        padding: 0.5em 1em;
        background-color: #d5eae7;
        color: #35907f;
        border: 2px solid #0ec5a4;
        border-radius: 5px;
        font-weight: bold;
        font-size: 16px;
        text-transform: uppercase;
        cursor: pointer;
    }
</style>
